import { FC, SVGProps } from "react";
import { useMirrorTransform } from "src/i18n/direction";

const ExchangeIcon: FC<SVGProps<SVGSVGElement>> = ({ transform, ...props }) => {
  const mirroredTransform = useMirrorTransform(transform as string | undefined);
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      transform={mirroredTransform}
      {...props}
    >
      <path d="M3 17.9799L5.54999 17.9899C6.45999 17.9899 7.31 17.5399 7.81 16.7899L14.2 7.20994C14.7 6.45994 15.55 5.99993 16.46 6.00993L21.01 6.02994" />
      <path d="M19 19.9805L21 17.9805" />
      <path d="M8.89001 8.62017L7.81 7.12017C7.3 6.41017 6.47999 5.99017 5.60999 6.00017L3 6.01018" />
      <path d="M12.9697 15.3799L14.1897 16.9499C14.6997 17.6099 15.4997 17.9999 16.3397 17.9999L21.0097 17.9799" />
      <path d="M21 6.01953L19 4.01953" />
    </svg>
  );
};

export default ExchangeIcon;
